import { render, staticRenderFns } from "./menu-sales-ordership.vue?vue&type=template&id=69b9e974&"
import script from "./menu-sales-ordership.vue?vue&type=script&lang=js&"
export * from "./menu-sales-ordership.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports